// @flow

import {
  WIZARD_EVENTS,
  type Wizard$CompletedEventPayload,
  type Wizard$MoreProductsLoadedEventPayload
} from '../types'

function setProducts ({ detail: eventPayload }: { detail: Wizard$CompletedEventPayload }) {
  window.chatchamp.products = eventPayload.products
}

function appendProducts ({ detail: eventPayload }: { detail: Wizard$MoreProductsLoadedEventPayload }) {
  window.chatchamp.products = window.chatchamp.products.concat(eventPayload.products)
}

export function registerChatchampPixelListeners (): void {
  if (window.trboAdvisorRegisteredChatchampPixelListeners) return

  window.trboAdvisorRegisteredChatchampPixelListeners = true
  window.addEventListener(WIZARD_EVENTS.Completed, setProducts)
  window.addEventListener(WIZARD_EVENTS.MoreProductsLoadedEvent, appendProducts)
}

// export only for testing
export function unregisterChatchampPixelListeners (): void {
  window.addEventListener(WIZARD_EVENTS.Completed, setProducts)
  window.addEventListener(WIZARD_EVENTS.MoreProductsLoadedEvent, appendProducts)
}
